// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CheckList_wrapper__vAGf5","ordered":"CheckList_ordered__CkSxm","grid":"CheckList_grid__u5gpI","flex":"CheckList_flex___OY8m","title":"CheckList_title__gmSIr"};